import VisualMovie from './VisualMovie'
import { gsap, Sine } from 'gsap';

class VisualVideoController {
  constructor(el) {
    this.dom = {el: el};
    // ラッパー要素（figure）を対象にする
    this.dom.visualMovie = this.dom.el.querySelector('.top-hero__movie')
    
    this.videoAspect = 1920 / 1080

    this.resize = this.resize.bind(this)

    // console.log('VisualVideoController - visualMovie element:', this.dom.visualMovie);
    
    if (this.dom.visualMovie) {
      this.dom.visualMovie.style.opacity = 0;
      this.vm = new VisualMovie(this.dom.visualMovie);
      // console.log('VisualMovie instance created:', this.vm);
    } else {
      // console.error('visualMovie element not found');
    }

    this.init();
  }

  init() {
    window.addEventListener('resize', this.resize)

    this.setVideoFullScreen()

    // hashがある場合は初期再生をスキップ
    const hasHash = window.location.hash && window.location.hash !== '#';

    gsap.to(this.dom.visualMovie, {
      opacity: 1,
      ease: Sine.easeInOut,
      duration: 1.2,
      onComplete: () => {
        // hashがない場合のみ初期再生
        if (!hasHash) {
          this.vm.onPlaying();
        }
      }
    })

    // オプション指定
    const options = {
      // ルートとして指定する要素。省略するとデフォルトはviewport
      // root: document.querySelector('.root'),

      // 交差する上下左右100px手前で発火させることができる
      // rootMargin: '100px',

      // 要素の見えている割合が20%を超える度にコールバックを実行
      threshold: [0.1]
    };
  
    // コールバック関数
    const callback = (entries) => {
      const ratio = entries[0].intersectionRatio;
      // console.log('IntersectionObserver callback - ratio:', ratio, 'hasHash:', hasHash);
      
      if (ratio <= .1) {
        console.log('Video pausing - out of view');
        this.vm.onPause();
      } else {
        // console.log('Video playing - in view');
        this.vm.onPlaying();
      }
    };
  
    const io = new IntersectionObserver(callback, options);
    io.observe(this.dom.visualMovie);

  }

  resize() {
    this.setVideoFullScreen()
  }

  setVideoFullScreen() {
    const windowAspect = window.innerWidth / window.innerHeight;
    // console.log({windowAspect}, this.videoAspect)
    if (this.videoAspect > windowAspect) {
      this.dom.visualMovie.dataset.aspect = 'vertical'
    } else {
      this.dom.visualMovie.dataset.aspect = 'horizontal'
    }
  }
}

export default VisualVideoController